import React, { useEffect, useRef } from 'react';

const FeatureCard = ({ icon, title, description, delay = 0 }) => {
    const cardRef = useRef(null);

    useEffect(() => {
        if (cardRef.current) {
            cardRef.current.style.transitionDelay = `${delay}s`;
        }
    }, [delay]);

    return (
        <div
            ref={cardRef}
            className="bg-primary-50 p-6 rounded-lg transition-all duration-300 hover:shadow-md"
        >
            <div className="p-3 bg-primary-100 rounded-lg inline-block mb-4">
                {React.cloneElement(icon, { className: "text-primary-600" })}
            </div>
            <h3 className="text-xl font-semibold mb-3">{title}</h3>
            <p className="text-gray-600">
                {description}
            </p>
        </div>
    );
};

export default FeatureCard;